import {
  EditorQueries,
  eventsFlux,
  EventTypes,
  nodesFlux,
  useEditorSelector,
} from '@candulabs/craft';
import { useMemo } from 'react';
import { createStructuredSelector } from 'reselect';

import { useEditor } from 'craft/hooks/useEditor';
import { Media } from 'craft/types';
import { traverseChildren } from 'craft/utils/traverseChildren';

export const isFocusWithinChild = (
  query: EditorQueries,
  selectedNodes: string[],
  nodeId: string,
) => {
  let res = false;

  traverseChildren(query, nodeId, (node) => {
    if (selectedNodes.includes(node.id)) {
      res = true;
      return true;
    }

    return false;
  });

  return res;
};

export const breakpointClassNames = (media: Media) => {
  const classNames = [];

  if (media.hidden) {
    classNames.push(...media.hidden.map((breakpoint) => `media-hidden-${breakpoint}`));
  }
  return classNames;
};

export const useMediaBreakpointClassNames = (id: string) => {
  const structuredSelector = useMemo(
    () =>
      createStructuredSelector({
        custom: nodesFlux.selectors.getNodeCustom(id),
        selectedNodes: eventsFlux.selectors.getNodesForEvent(EventTypes.selected),
      }),
    [id],
  );
  const { custom, selectedNodes } = useEditorSelector(structuredSelector);

  const { query } = useEditor();

  // nodes are 'selected' if they have focus, or their children have focus
  const selectionInHeirachy = useMemo(() => {
    if (selectedNodes.nodeIds.size === 0) {
      return false;
    }
    return isFocusWithinChild(query, Array.from(selectedNodes.nodeIds), id);
  }, [selectedNodes, id]);

  const classNames = [];

  if (custom?.media?.hidden) {
    custom.media.hidden.forEach((breakpoint: string) =>
      classNames.push(`media-hidden-${breakpoint}`),
    );
  }

  if (selectionInHeirachy) {
    classNames.push('node-selected');
  }

  return classNames.join(' ');
};
